import { accountKitReducer, AccountKitState } from "@nerdjs/account-kit";
import { kronosReducer, KronosState } from "../kronos-kit";
import {
  networkMiddleware,
  networkReducer,
  NetworkStateExpanded,
} from "@nerdjs/nerd-network";
import { notificationReducer } from "@nerdjs/nerd-ui";
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import thunkMiddleware from "redux-thunk";
import { appStatusReducer } from "./appStatus/appStatusReducer";
import { AppStatusState } from "./appStatus/appStatusState";
import { filmsMiddleware } from "./filmsMiddleware";
import { mainMiddleware } from "./mainMiddleware";
import { filmsApi } from "./api/filmsApi";
import { kronosApi } from "./kronos/kronosApi";
import { filmsSlice, FilmsState } from "./filmsReducer";

export interface AppState {
  films: FilmsState;
  accountKitState: AccountKitState;
  networkState: NetworkStateExpanded;
  appStatusState: AppStatusState;
  kronosState: KronosState;
}

const rootReducer = combineReducers({
  // this defines the shape of our MainState
  [filmsSlice.name]: filmsSlice.reducer,
  accountKitState: accountKitReducer,
  notification: notificationReducer,
  [filmsApi.reducerPath]: filmsApi.reducer,
  [kronosApi.reducerPath]: kronosApi.reducer,
  appStatusState: appStatusReducer,
  networkState: networkReducer,
  kronosState: kronosReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: [
    thunkMiddleware,
    filmsApi.middleware,
    kronosApi.middleware,
    filmsMiddleware,
    mainMiddleware,
    networkMiddleware,
  ],
});

export type AppDispatch = typeof store.dispatch;
